document.addEventListener("DOMContentLoaded", function (event) {
    window.addEventListener("load", function (e) {
		$("document").ready(function(){
			$("body").on("click",".menu-btn",function(){
				$("header").toggleClass('menu-opened');

				if($(".home-welcome .wp-block-group__inner-container >figure").length > 0){
					$(".home-welcome .wp-block-group__inner-container >figure").toggleClass('menu-opened');
				}

				if(window.innerWidth < 1521 && $("header").hasClass('menu-opened')){
					$("html").css('overflow','hidden');
				}else{
					$("html").css('overflow','auto');
				}
			});
		});

        //change lang name
        let lang = document.querySelectorAll('#menu-lang-menu li a span');
        lang[0].textContent = lang[0].getAttribute("lang");
        lang[1].textContent = lang[1].getAttribute("lang");

        let SujectInput = document.getElementsByName("sujet");

        if(SujectInput.length){
            let title = document.getElementsByClassName('title')[0].textContent;
            document.getElementsByName("sujet")[0].value = title;
        }

		if(window.innerWidth < 1281){
			$(".list-categories").on("click",".current-cat > a, .current > a", function(){
				$(this).parents('ul').find('li:not(.current-cat):not(.current)').slideToggle();
				$(this).toggleClass('opened');
				return false;
			});
		}
		

		if($(".agency-methods").length > 0){
			$(".agency-methods .swiper-wrapper").find('.wp-block-column').addClass('swiper-slide');
			if(window.innerWidth > 990){
				$(".agency-methods > .wp-block-group__inner-container")
				.append(
					$("<div/>")
					.addClass('nav-container')
					.append(
						$('<button/>')
						.addClass('agency-methods-prev')
						.html('<')
					)
					.append(
						$('<button/>')
						.addClass('agency-methods-next')
						.html('>')
					)
				);

				new Swiper('.agency-methods > .wp-block-group__inner-container', {
					speed: 400,
					spaceBetween: 50,
					slidesPerView: 1.2,
					navigation: {
						nextEl: '.agency-methods-next',
						prevEl: '.agency-methods-prev',
					},
					breakpoints: {
						991: {
							slidesPerView: 2.3
						},
					}
				});
			}
		}

		if($(".team-member-list").length > 0){
			new Swiper('.team-member-list', {
				speed: 400,
				spaceBetween: 0,
				slidesPerView: 1,
				navigation: {
					nextEl: '.team-member-next',
					prevEl: '.team-member-prev',
				},
			});
		}

		if($(".references-list-swiper").length > 0){
			$('.references-list-swiper li').addClass('swiper-slide');

			$(".references-list-swiper")
			.append(
				$("<div/>")
				.addClass('nav-container')
				.append(
					$('<button/>')
					.addClass('references-prev')
					.html('<')
				)
				.append(
					$('<button/>')
					.addClass('references-next')
					.html('>')
				)
			)
			.append(
				$("<div/>")
				.addClass("swiper-pagination")
			);

			new Swiper('.references-list-swiper .swiper', {
				speed: 400,
				spaceBetween: 23,
				slidesPerView: 1.1,
				navigation: {
					nextEl: '.references-next',
					prevEl: '.references-prev',
				},
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
					dynamicBullets: true,
					dynamicMainBullets: 1,
				},
				breakpoints: {
					770: {
						slidesPerView: 3
					},
				}
			});
		}

		if($(".is-style-logos-gallery").length > 0){

			$(".is-style-logos-gallery")
			.addClass('swiper')
			.append(
				$("<div/>")
				.addClass('swiper-wrapper')
			);

			$('.is-style-logos-gallery figure').addClass('swiper-slide').appendTo('.is-style-logos-gallery .swiper-wrapper');

			new Swiper('.is-style-logos-gallery.swiper', {
				speed: 400,
				spaceBetween: 23,
				slidesPerView: 2.5,
				autoplay: {
					delay: 2500,
					disableOnInteraction: false,
				},
				breakpoints: {
					770: {
						slidesPerView: 4
					},
					1280: {
						slidesPerView: 5
					},
				}
			});
		}

		if($(".home-welcome").length > 0){
			var logoEl = $(".home-welcome .wp-block-group__inner-container >figure");
			var initHeight = logoEl.height();

			setTimeout(function(){
				logoEl.addClass('smaller');

				setTimeout(function(){
					initHeight = logoEl.height();
				},2000);

				$(".home-welcome .wp-block-group__inner-container h1").addClass('visible');
				var wait = 400;
				$(".home-welcome .wp-block-group__inner-container .wp-block-columns .wp-block-column").each(function(){
					var el = $(this);
					wait = wait + 400;
					setTimeout(function(){
						el.addClass('visible');
					}, wait);
				});
				
				wait = wait + 750;
				setTimeout(function(){
					$(".menu-btn").addClass('visible');
					setTimeout(function(){
						$(".menu-btn").addClass('visible-done');
					},750);
				}, wait);
			},500);

			$(window).on("scroll touchmove", function() {

				if($(window).scrollTop() > 0){

					if(!logoEl.hasClass('scrolled')){
						$(".home-welcome .wp-block-group__inner-container .wp-block-columns .wp-block-column").each(function( index ){
							let timing = 500 * (index + 1);
							var el = $(this);
							setTimeout(function(){
								el.find('figure:first-of-type').hide();
								el.find('figure:last-of-type').fadeIn();
							}, timing);
						});
						

						if(window.innerWidth < 991){
							logoEl
							.addClass('scrolled')
							.animate({top: 56, left: 10, width: 43, height: 54}, 300)
							.css('transform', 'scale(1)');
						}else{
							logoEl
							.addClass('scrolled')
							.animate({top: 23, left: 50, width: 100, height: 108}, 300)
							.css('transform', 'scale(1)');
						}

						$(".container").css('padding-top', 'calc(100vh - ' + initHeight  + 'px)');
					}

				}else{
					$(".home-welcome .wp-block-group__inner-container .wp-block-columns .wp-block-column").each(function(){
						$(this).find('figure:first-of-type').fadeIn();
						$(this).find('figure:last-of-type').hide();
					});

					if(window.innerWidth < 991){
						var scale = 0.5;
						var topInit = "10";
					}else if(window.innerWidth < 1521){
						var scale = 0.8;
						var topInit = "10";
					}else{
						var scale = 1;
						var topInit = "20";
					}
					logoEl
					.removeClass('scrolled')
					.animate({top: topInit + 'vh', left: '50%'}, 100)
					.css('transform', 'translateX(-50%) scale(' + scale + ')')
					.css('width', 'initial')
					.css('height', 'initial');
					
					$(".container").css('padding-top', '100vh');
				}

				let heightStrateHome = $("#strate-home").height();

				if ($(document).scrollTop() >= $("#strate-home").position().top - (($("#strate-home").height() ))){
					let topScroll = ($(document).scrollTop() + heightStrateHome) - ($("#strate-home").position().top);

					let percentScroll = topScroll / heightStrateHome;

					$("#strate-home").addClass('animation');
					if(topScroll > 0){
						$("#reference-img img").css("transform", "scale("+(0.6*percentScroll)+")");
					}

				}else{
					$("#strate-home").removeClass('animation');
				}
			});
		}

		$(".faq__item .read_more_button, .faq__item--content > h3").click(function(e){
			e.preventDefault();
			$(this).parent('.faq__item--content').find('.answer').slideToggle();
			$(this).parent('.faq__item--content').find('.read_more_button').toggleClass('opened');

			return false;
		});
	});
}, false);